import React, { FunctionComponent } from "react";
import { ReactComponent as IconCrop } from "../../../../icons/crop.svg";
import { Length, Unit } from "../../../../types/customization/box";
import {
  Template,
  TemplateEditablePictureDefinition,
  TemplatePageDefinition,
} from "../../../../types/customization/template";
import "./style.scss";

interface Props {
  elementDefinition?: TemplateEditablePictureDefinition;
  pageDefinition: TemplatePageDefinition;
  placementValues: {
    height: Length<Unit.PX>;
    left: Length<Unit.PX>;
    top: Length<Unit.PX>;
    width: Length<Unit.PX>;
  };
  template: Template;
  type: "placeholder" | "resizableHover" | "border";
}

const ShapeBorders: FunctionComponent<Props> = ({
  elementDefinition,
  pageDefinition,
  placementValues,
  template,
  type,
}) => {
  let SVGShape: string | undefined;

  if (elementDefinition) {
    const elementShapeKey = elementDefinition.apparentShapeKey
      ? elementDefinition.apparentShapeKey
      : elementDefinition.shapeKey
      ? elementDefinition.shapeKey
      : null;
    if (elementShapeKey) {
      const elementShape = template.shapeDefinitions.find((shape) => shape.key === elementShapeKey);
      SVGShape = elementShape ? elementShape.svgContent : "";
    }
  }

  const pageShapeDefinition = template.shapeDefinitions.find(
    ({ key }) => key === pageDefinition.shapeKey
  );
  if (pageShapeDefinition) {
    const pageClippingSVG = pageShapeDefinition ? pageShapeDefinition.svgContent : null;
    SVGShape = pageClippingSVG ? pageClippingSVG : "";
  }

  return (
    <div
      className="ShapeBorders"
      style={{
        height: placementValues.height.value,
        left: placementValues.left.value,
        top: placementValues.top.value,
        width: placementValues.width.value,
      }}
    >
      {SVGShape ? (
        <div
          className={`ShapeBorders-${type}`}
          dangerouslySetInnerHTML={{
            __html: SVGShape,
          }}
        />
      ) : (
        <div className={`ShapeBorders-${type}-square`} />
      )}
      {type === "resizableHover" && <IconCrop className="ShapeBorders-resizableHover-icon" />}
    </div>
  );
};

export default ShapeBorders;
